import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AdditionalInformationDto,
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const URL = `${APIConfiguration.claim}orders/${COMMON_QUERY_PARAMS.ORDER_ID}/claimGroups`;

interface CreateClaimGroupFromOrder {
  orderId: string;
  orderLineReferences: string[];
  externalCaseId?: string;
  claimOrigin?: string;
  currentSite?: string;
  file?: File;
}

interface NewCreateClaimGroupFromOrderResponse {
  claimGroupId: string;
  additionalInformations: AdditionalInformationDto[];
}

export async function newCreateClaimGroupFromOrder({
  orderId,
  orderLineReferences,
  externalCaseId,
  claimOrigin,
  currentSite,
  file,
}: CreateClaimGroupFromOrder): Promise<
  BackResponse<NewCreateClaimGroupFromOrderResponse> | BackResponseFailure
> {
  try {
    const body = new FormData();

    body.append('fileBinary', file || '');
    body.append('orderLineReferences', orderLineReferences.join(','));
    body.append('externalCaseId', externalCaseId || '');
    body.append('claimOrigin', claimOrigin || '');
    body.append('currentSite', currentSite || '');

    return await apiCall<BackResponse<NewCreateClaimGroupFromOrderResponse>>(
      URL.replace(COMMON_QUERY_PARAMS.ORDER_ID, orderId),
      {
        method: SUPPORTED_METHODS.POST,
        body,
      },
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
